import FaqsContainer from "../../container/admin/faqs-master";

const Faqs = () => {
    return <FaqsContainer />;
};

export default Faqs;